import {useSelector} from "react-redux";
import {organisationSelectors} from "../../../organisationSelectors";
import {useIntl} from "react-intl";
import {useAppDispatch} from "../../../../../infrastructure/hooks/reduxHooks";
import {SubscriptionPageTitle} from "./SubscriptionPageTitle";
import {Route, Routes} from "react-router-dom";
import React from "react";
import {Success} from "./payment/Success";
import {Cancel} from "./payment/Cancel";
import {Detail} from "./detail/Detail";

export const SubscriptionPage = () => {

    const intl = useIntl()
    const dispatch = useAppDispatch()
    
    const organisation = useSelector(organisationSelectors.getSelectedOrganisation())

    return (
        <>
            <SubscriptionPageTitle/>
            <Routes>
                <Route path='success' element={<Success/>}/>
                <Route path='cancel' element={<Cancel/>}/>
                <Route path='*' element={<Detail/>}/>
            </Routes>
        </>
    )
}